import React from 'react';
import type { FC } from 'react';
import { Trans } from '@wix/cli-i18n';
import {
  Box,
  Key,
  Alert,
  Badge,
  Spinner,
  useInput,
  useAsyncCallback,
} from '@wix/cli-ui-kit';
import { openBrowser } from '@wix/user-browser';
import { useDevEnvironment } from './DevEnvironment.js';

export const DevCommandScreen: FC = () => {
  const { devEditorUrl, isDevEditorConnected, isSyncingChanges } =
    useDevEnvironment();
  const { execute: openDevEditor } = useAsyncCallback(() =>
    openBrowser(devEditorUrl)
  );

  useInput((input) => {
    if (input === 'e' && !isDevEditorConnected) {
      void openDevEditor();
    }
  });

  return (
    <>
      <Alert type="success">
        <Badge skin="success">
          <Trans i18nKey="general.success" />
        </Badge>{' '}
        <Trans i18nKey="dev_command.dev_environment.success" />
      </Alert>
      <Box marginTop={1} marginLeft={1}>
        {!isDevEditorConnected && (
          <Alert type="warning">
            <Trans
              i18nKey="dev_command.no_open_editor"
              components={[<Key value="E" />]}
            />
          </Alert>
        )}
        {isDevEditorConnected && (
          <>
            {isSyncingChanges ? (
              <Spinner
                text={<Trans i18nKey="dev_command.sync_changes.loading" />}
              />
            ) : (
              <Alert type="success">
                <Trans i18nKey="dev_command.sync_changes.success" />
              </Alert>
            )}
          </>
        )}
      </Box>
    </>
  );
};
